import React from "react";
import "../App.css";

 
  export default class Follower extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        username: props.followerList,
      }
      console.log("LOOK HERE", props.followerList);
    }
 
  render(){
    return(
    this.state.username.map((currentFollower)=>{return(
            <div className='accountBox_follower'key = {currentFollower.userId}>
                <a href={"./"+currentFollower.userId}>
                <br/>
                <img src={currentFollower.user_pic} alt={currentFollower.user} class="center"
                height='100'
                width='100'
                className='user_pic'
                />
                <br/>
                </a>
                {currentFollower.username}
            </div>)}
    ));
  }
}
